import React from 'react';

import { Container, IconWrapper, StyledInput } from './styled';
import type { InputProps } from './types';

export const Input: React.FC<InputProps> = ({
  variant = 'outline',
  size = 'medium',
  startIcon,
  endIcon,
  error = false,
  className,
  testId,
  styleProps,
  ...props
}) => {
  const hasStartIcon = Boolean(startIcon);
  const hasEndIcon = Boolean(endIcon);

  return (
    <Container
      className={className}
      $fullWidth={props.style?.width === '100%'}
      $styleProps={styleProps}
    >
      {hasStartIcon && (
        <IconWrapper position='start' $styleProps={styleProps}>
          {startIcon}
        </IconWrapper>
      )}
      <StyledInput
        $variant={variant}
        $size={size}
        $hasStartIcon={hasStartIcon}
        $hasEndIcon={hasEndIcon}
        $error={error}
        $styleProps={styleProps}
        data-testid={testId}
        {...props}
      />
      {hasEndIcon && (
        <IconWrapper position='end' $styleProps={styleProps}>
          {endIcon}
        </IconWrapper>
      )}
    </Container>
  );
};